/**
 * Pionowe menu sekcji otwartej oferty — renderowane w lewym `SubNav` (ciemny rail)
 * zamiast listy „Ostatnie oferty", gdy jesteśmy wewnątrz oferty (/oferty/:projectId).
 *
 * Dlaczego w sidebarze, nie poziomym paskiem u góry treści (jak było):
 *   - siedem sekcji w dwóch grupach nie mieści się czytelnie w jednym wierszu,
 *   - pionowa lista skaluje się bez ograniczeń (dojdzie ósma sekcja → kolejny wiersz),
 *   - spójnie z resztą aplikacji, gdzie nawigacja żyje po lewej.
 *
 * Stan sekcji nadal żyje w `?sekcja=` — ten komponent tylko go zapisuje/odczytuje,
 * więc stare linki i odświeżenie działają bez zmian. Na tablecie/mobile `.subnav`
 * jest ukryty przez CSS — tam sekcje pokazuje poziomy `OfferSectionsNav` w treści
 * (ProjectPage renderuje go z klasą `.offer-sections-inline`, widoczną tylko ≤1024px).
 */
import { useNavigate, useSearchParams } from "react-router-dom";
import { Icon } from "@/components/ui/Icon";
import {
  OFFER_SECTIONS,
  GROUP_LABEL,
  parseSection,
  type OfferSectionGroup,
} from "./offerSections";

const GROUPS: OfferSectionGroup[] = ["wiedza", "publikacja"];

export function OfferSectionsSidebar({ projectId }: { projectId: string }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const active = parseSection(searchParams.get("sekcja"));

  const goSection = (id: string) => {
    // Przegląd = brak parametru (domyślny widok), reszta = ?sekcja=<id>.
    const url = id === "przeglad" ? `/oferty/${projectId}` : `/oferty/${projectId}?sekcja=${id}`;
    navigate(url, { replace: true });
  };

  return (
    <>
      <div className="subnav__list">
        <button className="subitem" onClick={() => navigate("/oferty")}>
          <Icon name="arrowL" />
          <span>Wszystkie oferty</span>
        </button>
      </div>
      <div className="subnav__divider" />

      {GROUPS.map((group) => (
        <div key={group}>
          <div className="subnav__label micro">{GROUP_LABEL[group]}</div>
          <div className="subnav__list" style={{ paddingTop: 0 }}>
            {OFFER_SECTIONS.filter((s) => s.group === group).map((s) => (
              <button
                key={s.id}
                className={`subitem ${active === s.id ? "is-active" : ""}`}
                aria-current={active === s.id ? "page" : undefined}
                onClick={() => goSection(s.id)}
              >
                <Icon name={s.icon} />
                <span>{s.label}</span>
                {s.soon && (
                  <span
                    style={{
                      marginLeft: "auto",
                      fontSize: 9.5,
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                      textTransform: "uppercase",
                      padding: "2px 6px",
                      borderRadius: 999,
                      background: "rgba(255,255,255,0.06)",
                      color: "var(--text-2)",
                    }}
                  >
                    wkrótce
                  </span>
                )}
              </button>
            ))}
          </div>
        </div>
      ))}
    </>
  );
}
